module.exports = __webpack_public_path__ + "img/img-10.d4de01a5.jpg";